/**
 * DR-4976 — the serial component of a project-graph part node id (`part:<P/N>|<S/N>`, both segments URI-encoded).
 * The serial ignores every whitespace, so "PC 354858" and "PC354858" are one part. The P/N keeps its spelling: the
 * same serial on two P/Ns stays two parts. Pure, so the app bundles it beside the server.
 */
const PART_PREFIX = 'part:';
const SEP = '|';
/** Trimmed, upper-cased, every whitespace removed. */
export function partSerialKey(serial) {
    return serial.trim().toUpperCase().replace(/\s+/g, '');
}
/**
 * Rewrites a part node id to the current serial key, so an id saved before DR-4976 (`…|PC%20354858`) names the node
 * the graph draws now. A non-part id, an id without `|`, or a serial segment that does not decode comes back
 * unchanged. Idempotent; the P/N segment is untouched.
 */
export function foldPartNodeId(id) {
    if (!id.startsWith(PART_PREFIX))
        return id;
    const sep = id.indexOf(SEP);
    if (sep === -1)
        return id;
    try {
        const serial = decodeURIComponent(id.slice(sep + 1));
        return `${id.slice(0, sep + 1)}${encodeURIComponent(partSerialKey(serial))}`;
    }
    catch {
        return id;
    }
}
//# sourceMappingURL=partNodeKey.js.map